import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import type { ComposeType } from "@/types/email-composer"

/**
 * The e-mail composer on the lead page. It is opened from several places
 * (header, contact card, a mail in the timeline), so what it was asked to do
 * lives here, like the forms it replaces.
 */
export type MailComposerRequest = {
  leadId: number
  type: ComposeType
  /** The mail that is answered or forwarded. */
  parentMailId?: number | null
  /** A draft that is opened again by name (a scheduled mail). */
  draftId?: number | null
  to?: string | null
  subject?: string | null
  contactId?: number | null
  contactInfoId?: number | null
}

type MailComposerState = { isOpen: boolean; request: MailComposerRequest | null; opened: number }

const initialState: MailComposerState = { isOpen: false, request: null, opened: 0 }

const mailComposerSlice = createSlice({
  name: "mailComposer",
  initialState,
  reducers: {
    openMailComposer: (state, action: PayloadAction<MailComposerRequest>) => {
      state.isOpen = true
      state.request = action.payload
      // Every opening is a new session, also for the same mail.
      state.opened += 1
    },
    closeMailComposer: (state) => {
      state.isOpen = false
      state.request = null
    },
  },
})

export const { openMailComposer, closeMailComposer } = mailComposerSlice.actions
export default mailComposerSlice.reducer
